import React from 'react';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import data from '@/seo/pages.json';
import { servicePages } from '@/seo/core.mjs';

// Shared public footer. Lists every service page so people (and search
// engines) can reach each one from the home page and from each other.
export default function SiteFooter() {
  const services = servicePages(data);
  return (
    <footer className="py-12 px-6 border-t border-slate-800" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <nav aria-label="Services" className="mb-8">
          <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-400 mb-3">What we offer</h2>
          <ul className="flex flex-wrap gap-x-6 gap-y-1">
            {services.map((s) => (
              <li key={s.path}>
                <Link to={s.path} className="inline-flex items-center min-h-[44px] text-slate-300 hover:text-white transition-colors" data-testid={`footer-service-${s.path.slice(1)}`}>{s.navLabel}</Link>
              </li>
            ))}
            <li>
              <Link to="/pricing" className="inline-flex items-center min-h-[44px] text-slate-300 hover:text-white transition-colors">Pricing</Link>
            </li>
          </ul>
        </nav>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-indigo-500 rounded flex items-center justify-center"><Globe className="w-4 h-4 text-white" /></div>
            <span className="text-sm text-slate-500">EasyPeazy &copy; {new Date().getFullYear()}</span>
          </div>
          <div className="flex items-center gap-5">
            <Link to="/terms" className="inline-flex items-center min-h-[44px] px-2 text-sm text-slate-500 hover:text-slate-300 transition-colors" data-testid="footer-terms-link">Terms</Link>
            <Link to="/privacy" className="inline-flex items-center min-h-[44px] px-2 text-sm text-slate-500 hover:text-slate-300 transition-colors" data-testid="footer-privacy-link">Privacy</Link>
            {data.site.parent && (
              <a href={data.site.parent.url} className="inline-flex items-center min-h-[44px] px-2 text-sm text-slate-500 hover:text-slate-300 transition-colors" data-testid="footer-parent-link">Part of {data.site.parent.name}</a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
